<template>
  <div class="col-11 mx-auto px-0">
    <transition name="fade" id="vitals">
      <div
        v-if="this.latest"
        class="d-flex flex-wrap row mx-auto justify-content-between flex__list"
      >
        <div
          v-for="(param, ind) in this.latest"
          :key="ind"
          class="my-2 d-flex text-center"
        >
          <span class="text-secondary px-0 mr-1"
            >{{ param.record.esame }}: {{ param.record.valore }}</span
          >
          <span
            class="text-secondary col edit__link px-0 mr-1 text-right"
            @click="$emit('add-storico', param.record.esame)"
            >Vedi storico</span
          >
          <!-- <span
            class="text-secondary col edit__link px-0 mr-1 text-right"
            @click="goTo(param.record.esame)"
          >Vedi storico</span>-->
        </div>
      </div>
      <p v-else>{{ msg }}</p>
    </transition>
    <div class="pt-3">
      <h5 v-if="showContainer" @click="closeAll" class="text-right mr-3 mb-0">
        <b-button variant="primary font-weight-bold" size="sm">Chiudi</b-button>
      </h5>
      <h4
        v-if="this.latest"
        class="text-secondary under__line point"
        @click="showContainer = true"
      >
        Aggiungi nuovo Parametro
      </h4>
    </div>
    <transition-group name="fade">
      <div v-show="showContainer" key="uno">
        <!-- <transition name="fade" id="container"> -->
        <div class="d-flex flex-wrap mt-2 justify-content-between">
          <b-button
            v-for="(esame, ind) in this.esami"
            :key="ind"
            variant="secondary text-capitalize font-weight-bold"
            class="my-3 col-3 mx-3 min__h"
            @click="showAdd(esame.id, esame.nome, esame.um)"
            >{{ esame.nome }}</b-button
          >
        </div>
        <!-- </transition> -->
        <transition name="list" id="insert">
          <div class="col-10 mx-auto mt-2 pb-3" v-show="showDiv" key="due">
            <b-overlay :show="loading" rounded="sm" spinner-variant="secondary">
              <b-form @submit="onSubmit" @reset="clear">
                <b-form-group
                  :label="label"
                  class="text-left text-capitalize d-flex text-secondary"
                >
                  <b-input-group
                    :prepend="this.um"
                    class="mb-2 mr-sm-2 mb-sm-0"
                  >
                    <b-input
                      v-model="form.valore"
                      type="number"
                      step="0.01"
                      required
                      autofocus
                      placeholder="Inserisci valore*"
                    ></b-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group label="Note" class="text-left text-secondary">
                  <b-form-textarea
                    v-model="form.note"
                    placeholder="Inserisci nota(facoltativo)"
                  ></b-form-textarea>
                </b-form-group>
                <b-button
                  type="reset"
                  variant="outline-primary mr-4 font-weight-bold"
                  >Annulla</b-button
                >
                <b-button type="submit" variant="primary font-weight-bold"
                  >Salva</b-button
                >
              </b-form>
            </b-overlay>
          </div>
        </transition>
      </div>
    </transition-group>
  </div>
</template>
<script>
// import Spinner from "@/components/Spinner.vue";
export default {
  name: "parametri-vitali",
  components: {
    // Spinner
  },
  data() {
    return {
      showContainer: false,
      esami: null,
      latest: null,
      showDiv: false,
      form: {
        esame_id: null,
        valore: null,
        note: null,
      },
      label: null,
      um: null,
      loading: false,
      msg: null,
    };
  },
  methods: {
    fetchEsami() {
      var url = process.env.VUE_APP_VERSION + "esame";
      this.$axios
        .get(url)
        .then((res) => {
          this.esami = res.data.data;
        })
        .catch(() => {
          //   this.$router.go();
        });
    },
    fetchLatest() {
      var url = process.env.VUE_APP_VERSION + "rilevazione/latest";
      this.$axios
        .get(url)
        .then((res) => {
          this.latest = res.data.data;
          this.msg = "Non hai ancora registrato alcun parametro";
        })
        .catch(() => {
          //   this.$router.go();
        });
    },
    showAdd(id, nome, um) {
      // console.log(id);
      this.showDiv = true;
      this.label = nome;
      this.um = um;
      this.form.esame_id = id;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.loading = true;
      this.sendForm();
    },
    clear(e) {
      e.preventDefault();
      this.showDiv = false;
      this.form = {
        esame_id: null,
        valore: null,
        note: null,
      };
    },
    sendForm() {
      var url = process.env.VUE_APP_VERSION + "rilevazione";
      this.form.valore = Number(this.form.valore);
      this.$axios
        .post(url, this.form)
        .then(() => {
          this.loading = false;
          this.showDiv = false;
          this.fetchLatest();
        })
        .catch((err) => {
          console.log(err);
        });
      this.form = {
        esame_id: null,
        valore: null,
        note: null,
      };
    },
    closeAll() {
      this.showContainer = false;
      this.showDiv = false;
    },
  },
  created() {
    this.fetchEsami();
    this.fetchLatest();
  },
};
</script>
<style scoped>
.min__h {
  min-height: 80px;
  min-width: 115px;
}
.card__w {
  width: 60vw;
}
.list-enter-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  /* transition-property: opacity; */
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}
.list-leave-active {
  position: absolute;
}
.list-leave-active {
  transition: 100ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-500px) scaleY(0);
  transform-origin: center top;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.flex__list div {
  width: calc(50% - 1.5rem);
  margin-right: auto;
  margin-left: 0.75rem;
}
.flex__list div:last-child {
  margin-right: auto;
  margin-left: 0.75rem;
}
.under__line {
  text-decoration: underline;
}
/* .hide {
  visibility: hidden;
} */
</style>
